import React from 'react';
import { Toaster } from 'sonner';
import ConfirmationModal from '../modals/ConfirmationModal';
import InactiveUserModal from '../modals/InactiveUserModal';
import { InstallPWADrawer } from '../data-display/InstallPWADrawer';
import { UpdateNotification } from '../data-display/UpdateNotification';
import VersionUpdatePrompt from '../VersionUpdatePrompt';
import { MessageNotificationManager } from '../chat/MessageNotificationManager';
import { FirebaseBackgroundConnector } from '../chat/FirebaseChatGuard';

const GlobalWrappers = ({
  versionInfo,
  showUpdatePrompt,
  dismissUpdatePrompt,
  forceRefresh,
  children
}) => {
  return (
    <>
      {children}

      {/* In-app message push notification (full-width, theme-aware) */}
      <MessageNotificationManager />

      {/* Silently negotiates Firebase token after login */}
      <FirebaseBackgroundConnector />

      <ConfirmationModal />
      <InactiveUserModal />
      <InstallPWADrawer />
      <UpdateNotification />
      <VersionUpdatePrompt
        isVisible={showUpdatePrompt}
        versionInfo={versionInfo}
        onDismiss={dismissUpdatePrompt}
        onRefresh={forceRefresh}
      />

      <Toaster
        richColors
        position="top-center"
        closeButton={true}
        theme="light"
        expand={true}
        duration={2500}
        gap={8}
        visibleToasts={5}
        aria-label={undefined}
        toastOptions={{
          className: 'font-sans',
          classNames: {
            closeButton: '!left-auto !right-3 !top-1/2 !-translate-y-1/2 !transform !bg-transparent !border-0 hover:!bg-black/5 !transition-colors',
          },
          style: {
            borderRadius: '12px',
            padding: '12px 40px 12px 16px',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: '1.3',
            maxWidth: '90vw',
            minWidth: '280px',
          }
        }}
        style={{
          top: '65px'
        }}
      />
    </>
  );
};

export default GlobalWrappers;